<!-- hasta aca los cambios -->
<template>
    <v-container fluid class="cbc-analyzer-container">
        <!-- Barra de encabezado con datos del usuario -->
        <v-app-bar app color="white" dark>
            <v-img src="../../images/fishbone-logo.jpg" :min-width="isMobile ? 100 : 900" class="mr-4 logo"></v-img>

            <template v-if="isMobile">
                <v-btn icon @click="showPatientInfo = !showPatientInfo">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
            </template>

            <!-- Datos dinámicos (Edad, Género, Peso, Estatura, Etnia) -->
            <template v-else>
                <v-spacer></v-spacer>
                <v-btn @click="$router.push({ name: 'Dashboard' })" color="primary" class="mr-3">
                    <v-icon left>mdi-arrow-left</v-icon> <!-- Puedes usar otro icono si lo prefieres -->
                    Regresar
                </v-btn>
                <v-select v-model="selectedGender" :items="genders" label="Género" outlined dense :disabled="true"
                    class="mr-3"></v-select>
                <v-text-field v-model="age" label="Edad" outlined dense :disabled="true" class="mr-3"></v-text-field>
                <v-text-field v-model="weight" label="Peso (kgs)" outlined dense :disabled="true"
                    class="mr-3"></v-text-field>
                <v-text-field v-model="height" label="Estatura (cm)" outlined dense :disabled="true"
                    class="mr-3"></v-text-field>
                <v-select v-model="selectedEthnicity" :items="ethnicities" label="Etnia" outlined dense
                    :disabled="true"></v-select>
                <v-btn :href="'/'" color="primary" class="mr-3">
                    <v-icon left>mdi-logout</v-icon>
                    Salir
                </v-btn>
            </template>
        </v-app-bar>

        <v-navigation-drawer v-model="showPatientInfo" temporary right>
            <v-list>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="title">Datos del Paciente</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>

                <!-- Campos de datos -->
                <v-list-item>
                    <v-select v-model="selectedGender" :items="genders" label="Género" outlined dense
                        :disabled="true"></v-select>
                </v-list-item>
                <v-list-item>
                    <v-text-field v-model="age" label="Edad" outlined dense :disabled="true"></v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-text-field v-model="weight" label="Peso (kgs)" outlined dense :disabled="true"></v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-text-field v-model="height" label="Estatura (cm)" outlined dense :disabled="true"></v-text-field>
                </v-list-item>
                <v-list-item>
                    <v-select v-model="selectedEthnicity" :items="ethnicities" label="Etnia" outlined dense
                        :disabled="true"></v-select>
                </v-list-item>

            </v-list>
        </v-navigation-drawer>


        <!-- Cuerpo Principal -->
        <v-row class="mt-5">
            <!-- Publicidad Izquierda (Visible solo en pantallas grandes) -->
            <v-col cols="12" sm="1" class="advertisement left-ad" v-if="!isMobile">
            </v-col>

            <!-- Panel Principal -->
            <v-col :cols="isMobile ? 12 : 10">
                <v-row style="margin: 0;" class="flex-container">
                    <!-- Izquierda 70% -->
                    <v-col :cols="isMobile ? 12 : 7" class="principal">

                        <v-card class="analyzer-card" style="border-radius: 4em;">
                            <v-card-title class="text-center"
                                style="font-size:3em; font-family:Georgia, 'Times New Roman', Times, serif;">Lipid Panel
                                Analyzer</v-card-title>
                            <!-- Fishbone Analyzer Diagram -->

                            <div class="fishbone-container">
                                <v-row class="mt-4" align="center" :justify="isMobile ? 'end' : 'start'">
                                    <v-col cols="auto">
                                        <v-btn
                                            :href="'https://tools.acc.org/ascvd-risk-estimator-plus/#!/calculate/estimate'"
                                            target="_blank" class="fishbone-input btn">
                                            10-Year ASCVD Risk
                                        </v-btn>

                                    </v-col>
                                </v-row>

                                <v-text-field v-model="fields.cholesterol" label="TC (mg/dL)" outlined dense
                                    class="fishbone-input cholesterol"></v-text-field>
                                <v-text-field v-model="fields.cholesterolhdl" label="HDL (mg/dL)" outlined dense
                                    class="fishbone-input cholesterolhdl"></v-text-field>
                                <v-text-field v-model="fields.triglycerides" label="TGs (mg/dL)" outlined dense
                                    class="fishbone-input triglycerides"></v-text-field>


                            </div>
                            <v-btn @click="clearFields" color="yellow" class="mt-4" block>
                                Limpiar Campos
                            </v-btn>

                        </v-card>

                    </v-col>



                    <!-- Derecha 30% -->
                    <v-col :cols="isMobile ? 12 : 5" class="right-panel">
                        <v-card class="data-card" style="max-height:fit-content">
                            <v-card-title class="text-center"
                                style="background-color:transparent; font-size:2.5em ; color: white;">Diagnóstico</v-card-title>
                            <v-row dense style="align-items: center">
                                <v-col cols="12" v-for="(item, index) in additionalData" :key="index">
                                    <v-card class="data-box" outlined v-if="item.value">
                                        <v-card-actions>
                                            <!-- Botón que abre el banner -->
                                            <v-btn text color="primary" @click="openBanner(item.label, item.value);">
                                                Ver más detalles
                                            </v-btn>
                                        </v-card-actions>
                                        <v-card-text class="diagnosis-text">{{ item.label }}: {{ item.value
                                        }}</v-card-text>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <!-- Dialogo para mostrar el "banner" -->
                            <v-dialog v-model="showBanner" max-width="600">
                                <v-card class="banner-card rounded-xl elevation-6 pa-4">
                                    <v-card-title class="text-h5 font-weight-bold pb-2">{{ selectedLabel
                                    }}</v-card-title>

                                    <v-card-text>
                                        <v-expansion-panels focusable inset>
                                            <v-expansion-panel v-for="(info, i) in bannerData" :key="i">
                                                <v-expansion-panel-header>
                                                    <span class="text-subtitle-1 font-weight-bold">{{ info.title
                                                    }}</span>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-list dense>
                                                        <v-list-item v-for="(detail, j) in info.details" :key="j"
                                                            class="py-1">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="text-body-2">
                                                                    • {{ detail }}
                                                                </v-list-item-title>
                                                            </v-list-item-content>
                                                        </v-list-item>
                                                    </v-list>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-card-text>

                                    <v-card-actions class="justify-end">
                                        <v-btn color="primary" variant="text" @click="showBanner = false">Cerrar</v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-card class="data-box" outlined v-if="infusionRate">
                                <v-card-text>Tasa de Infusión: {{ infusionRate }}</v-card-text>
                            </v-card>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>

            <!-- Publicidad Derecha (Visible solo en pantallas grandes) -->
            <v-col cols="12" sm="1" class="advertisement right-ad" v-if="!isMobile">
            </v-col>
        </v-row>

        <!-- Publicidad Inferior -->
        <v-row class="advertisement botton-ad mt-4">
            <v-col cols="12">
            </v-col>
        </v-row>
    </v-container>
</template>

<!-- un cambio mas arriba -->
<script>
import { ref, onMounted } from 'vue';
import axios from 'axios';
const apiUrl = process.env.VUE_APP_API_URL;


export default {


    setup() {
        const parametros = ref({});
        const cargarParametros = async () => {
            try {
                const response = await axios.get(`${apiUrl}/api/parameters`);
                const data = response.data;
                const parametrosMap = {
                    cholesterol: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    cholesterolhdl: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' },
                    triglycerides: { valorMostrado: '', valorAlto: '', valorBajo: '', units: '', rango: '' }

                };

                data.forEach((param) => {
                    switch (param.parametro.toLowerCase()) {
                        case 'cholesterol':
                            parametrosMap.cholesterol = {
                                valorMostrado: param.valorMostrado,
                                valorAlto: param.valorAlto || '',   // Si no existe, se asigna un valor vacío
                                valorBajo: param.valorBajo || '',
                                units: param.units || '',
                                rango: param.rango || ''
                            };
                            break;
                        case 'cholesterolhdl':
                            parametrosMap.cholesterolhdl = {
                                valorMostrado: param.valorMostrado,
                                valorAlto: param.valorAlto || '',
                                valorBajo: param.valorBajo || '',
                                units: param.units || '',
                                rango: param.rango || ''
                            };
                            break;
                        case 'triglycerides':
                            parametrosMap.triglycerides = {
                                valorMostrado: param.valorMostrado,
                                valorAlto: param.valorAlto || '',
                                valorBajo: param.valorBajo || '',
                                units: param.units || '',
                                rango: param.rango || ''
                            };
                            break;

                    }
                });
                parametros.value = parametrosMap;

                console.log(parametros.value);  // Accede a valorMostrado de paco2

                localStorage.setItem('parametros', JSON.stringify(parametros.value));
            } catch {
                console.error('Error al cargar parámetros:', error);
                console.log('Error al cargar parámetros:', error);
            }
        };
        onMounted(() => {
            const savedParams = localStorage.getItem('parametros');
            if (savedParams) {
                parametros.value = JSON.parse(savedParams);
            }

            cargarParametros();
        });

        return { parametros };
    },

    data() {
        return {
            showBanner: false, // Estado del banner
            selectedLabel: "", // Etiqueta seleccionada
            bannerData: [], // Información detallada del banner
            showPatientInfo: false,
            aniongap: 0,
            fields: {
                cholesterol: '',
                cholesterolhdl: '',
                triglycerides: '',
            },
            selectedGender: null,
            age: null,
            weight: null,
            height: null,
            selectedEthnicity: null,
            etniaid: null,
            smoker: false,
            diabetes: false,
            treated: false,
            diagnosisOne: '',
            diagnosisOneDesc: '',
            diagnosisPlt: '',
            diagnosisPltDesc: '',
            additionalData: [


                { label: 'Diagnóstico cholesterol', value: '' },
                { label: 'Diagnóstico cholesterol HDL', value: '' },
                { label: 'Diagnóstico triglycerides', value: '' },
                { label: 'Diagnostico LDL', value: '' },
                { label: 'Diagnostico Total Cholesterol/HDLCholesterol', value: '' },

            ],
            // Variables necesarias para la tasa de infusión
            genderVal: null,
            weightVal: null,
            ageVal: null,
            ivna: null,
            ivk: null,
            naChange: null,
            infusionRate: null, // Para guardar la tasa de infusión calculada
            individualDiagnoses: [], // Nuevo arreglo para guardar diagnósticos individuales

            diagnostico1: '',
            diagnostico2: ''
        };
    },
    computed: {

        isMobile() {
            return this.$vuetify.display.mdAndDown;
        },

        // Lógica para calcular diagnósticos según los valores
        diagnosis() {

            const cholesterol = this.convertToNumber(this.fields.cholesterol);
            const cholesterolhdl = this.convertToNumber(this.fields.cholesterolhdl);
            const triglycerides = this.convertToNumber(this.fields.triglycerides);

            console.log("Triglycerides antes de conversión:", this.fields.triglycerides);
            console.log("Triglycerides después de conversión:", triglycerides);

            console.log("cholesterol antes de conversión:", this.fields.cholesterol);
            console.log("cholesterol después de conversión:", cholesterol);


            this.additionalData[0].value = cholesterol ? this.evaluatecholesterol(cholesterol) : '';
            this.additionalData[1].value = cholesterolhdl ? this.evaluatecholesterolhdl(cholesterolhdl) : '';
            this.additionalData[2].value = triglycerides ? this.evaluatetriglycerides(triglycerides) : '';
            this.additionalData[3].value = this.evaluateLDL();
            this.additionalData[4].value = this.evaluateTotal();

        }

    },
    methods: {

        clearFields() {
            // Limpiar los campos de texto
            this.fields.cholesterol = '';
            this.fields.cholesterolhdl = '';
            this.fields.triglycerides = '';

            // Limpiar los datos dentro de additionalData
            this.additionalData.forEach(item => {
                if (item.label !== 'Diagnostico Primario' && item.label !== 'Diagnostico Secundario') {
                    item.value = ''; // Limpiar solo los valores de los otros campos
                }
            });

            // Hacer desaparecer "Diagnóstico Primario" y "Diagnóstico Secundario"
            const primary = this.additionalData.find(item => item.label === 'Diagnostico Primario');
            const secondary = this.additionalData.find(item => item.label === 'Diagnostico Secundario');
            if (primary) {
                primary.value = '';
            }
            if (secondary) {
                secondary.value = '';
            }
        },
        openBanner(label, value) {
            this.selectedLabel = label;
            this.showBanner = true;

            axios.get(`${apiUrl}/api/enfermedades/filter?enfermedad=${value}`)
                .then(response => {
                    const enfermedad = response.data[0]; // asumimos que es único

                    if (enfermedad) {
                        this.bannerData = [
                            {
                                title: "Differential Diagnosis",
                                details: enfermedad.descripcion
                                    ? enfermedad.descripcion.split('\n').map(str => str.trim()).filter(Boolean)
                                    : ["Sin descripción disponible"]
                            },
                            {
                                title: "Workup",
                                details: enfermedad.tratamiento
                                    ? enfermedad.tratamiento.split('\n').map(str => str.trim()).filter(Boolean)
                                    : ["Sin tratamiento disponible"]
                            },
                        ];
                    } else {
                        this.bannerData = [
                            {
                                title: "Información no encontrada",
                                details: ["No se encontró información en la base de datos para esta enfermedad."],
                            },
                        ];
                    }
                })
                .catch(error => {
                    console.error("Error al obtener los datos:", error);
                    this.bannerData = [
                        {
                            title: "Error",
                            details: ["Hubo un problema al consultar los datos de la base de datos."],
                        },
                    ];
                });
        },

        fieldLabel(field) {
            const labels = {
                cholesterol: 'cholesterol',
                cholesterolhdl: 'cholesterol HDL',
                triglycerides: 'triglycerides'
            };
            return labels[field] || field;
        },

        calcularLDL() {
            // Convertir los valores de los campos a números
            let LDL = 0;
            const cholesterolhdl = this.convertToNumber(this.fields.cholesterolhdl);
            const triglycerides = this.convertToNumber(this.fields.triglycerides);

            LDL = cholesterolhdl - (triglycerides / 5)

            if (triglycerides > 390) {
                return 'unable to calculate'
            }

            return LDL;
        },

        convertToNumber(value) {
            if (typeof value === 'string' && value.endsWith('K')) {
                return parseInt(value.slice(0, -1)) * 1000;
            }
            return parseFloat(value);
        },
        resetForm() {
            for (let field in this.fields) {
                this.fields[field] = ''; // Reset all fields to empty
            }
        },

        // Métodos de evaluación para cada campo

        evaluatecholesterol(cholesterol) {
            if (cholesterol < 200) return 'Normal';
            else if (cholesterol > 200) return 'High';

        },
        evaluatecholesterolhdl(cholesterolhdl) {
            if (cholesterolhdl > 50) return 'Normal';
            else if (cholesterolhdl < 50) return 'Low';

        },

        evaluatetriglycerides(triglycerides) {
            console.log(triglycerides);
            if (triglycerides < 150) return 'Normal';
            else if (triglycerides > 151 && triglycerides < 300) return 'Moderately High';
            else if (triglycerides > 301 && triglycerides < 900) return 'Very High';
            else if (triglycerides > 900) return 'Critical';

        },

        evaluateLDL() {
            const ldl = this.calcularLDL()

            if (ldl < 70) return 'Optimal';
            else if (ldl > 70 && ldl < 100) return 'Optimal';
            else if (ldl > 100 && ldl < 129) return 'Near Optimal';
            else if (ldl > 130 && ldl < 159) return 'Borderline  Hight';
            else if (ldl > 160 && ldl < 189) return 'High';
            else if (ldl > 190) return 'Very High';
        },
        evaluateTotal() {
            const cholesterol = this.convertToNumber(this.fields.cholesterol);
            const cholesterolhdl = this.convertToNumber(this.fields.cholesterolhdl);
            let total = 0;

            total = cholesterol / cholesterolhdl
            if (total < 3.5) return 'Optimal';
            else if (total > 3.5 && total < 5) return 'Normal';
            else if (total > 5) return 'Abnormal';


        }



    },

    watch: {
        fields: {
            handler: async function () {
                this.diagnosis

            },
            deep: true
        }
    },


    mounted() {
        // Asignar valores desde Vuex a las variables del componente
        this.selectedGender = this.$store.state.user.gender;
        this.age = this.$store.state.user.age;
        this.weight = this.$store.state.user.weight;
        this.height = this.$store.state.user.height;
        this.selectedEthnicity = this.$store.state.user.ethnicity;
        this.etniaid = this.$store.state.user.etniaid
        const savedParams = localStorage.getItem('parametros')
    }

};

</script>

<style scoped>
.botton-ad {
    background-image: url('../../images/bajamicro.jpg');
    /* Cambia a la ruta de tu imagen o GIF */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 50em;
    /* Altura fija */
    max-width: 100%;
    /* Asegura que no desborde horizontalmente */
    overflow: hidden;
}

.right-ad {
    background-image: url('../../images/izquierda.avif');
    /* Cambia a la ruta de tu imagen o GIF */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 50em;
    /* Altura fija */
    max-width: 100%;
    /* Asegura que no desborde horizontalmente */
    overflow: hidden;
}

.left-ad {
    background-image: url('../../images/izquierda.avif');
    /* Cambia a la ruta de tu imagen o GIF */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 50em;
    /* Altura fija */
    max-width: 100%;
    /* Asegura que no desborde horizontalmente */
    overflow: hidden;
}

.banner-card {
    background-image: url('../../images/lipidan.jpeg');
    background-size: cover;
    background-position: center;
    color: white;
}

.banner-overlay {
    background-color: rgba(255, 255, 255, 0.8);
    padding: 16px;
    border-radius: 8px;
}

.flex-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
}

.principal {
    flex: 1 0 140px;

}

.right-panel {
    background-color: transparent;
    flex: 1 0 120px;
}






/* Fondo completo para la página */
.cbc-analyzer-container {
    background-image: url('../../images/lipidan.jpeg');
    background-size: cover;
    /* Hace que la imagen de fondo cubra todo el área */
    background-position: center;
    /* Centra la imagen */
    min-height: 100vh;
    /* Hace que la altura mínima sea el 100% de la pantalla */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}



/* Estilos generales de la interfaz */
.cbc-analyzer-container {
    background-color: #f0f0f0;
}

.advertisement {
    background-color: #d3d3d3;
    /*     opacity: 0.2; */
    min-height: 2em;
    text-align: center;
}

.analyzer-card {
    background-color: transparent;
    color: white;
    padding: 20px;


}

/* Estilos del diagrama tipo fishbone */
.fishbone-container {
    position: relative;
    width: 100%;
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background-color: #00aaff; */
    background-image: url('../../images/analyzer_acid.png');
    background-size: 90%;
    background-position: center 50%;
    background-repeat: no-repeat;
    border-radius: 1em;
}

.fishbone-input {
    position: absolute;
    /* width: 80px; */
    text-align: center;
    background-color: white;
    color: grey;
    border-radius: 5%;
    font-weight: 900;
    max-height: 3em;
    min-width: 5.5em;
}

.data-box {
    background-color: white;
    /* Fondo blanco */
    border-radius: 12px;
    /* Bordes redondeados */
    border: 1px solid #374b40;
    /* Borde azul claro */
    margin-bottom: 10px;
    /* Separación entre los cuadros */
    padding: 10px;
    text-align: center;
    max-width: 25em;
    align-items: center
}

/* Estilo para el texto dentro de los cuadros */
.diagnosis-text {
    color: #00aaff;
    /* Color de texto celeste */
    font-weight: bold;
    /* Texto en negrita */
    font-size: 1.2rem;
    /* Aumentar tamaño de la fuente */
}

/* Contenedor donde se encuentra la imagen */
.fishbone-container {
    position: relative;
    width: 100%;
    height: 400px;
    /* Mantén un tamaño adecuado o ajusta */
    background-color: #c5972d;
    /* Opcional, para que puedas ver el área de la imagen */
}

/* Estilo de la imagen */
.analyzer-background {
    position: absolute;
    top: -60px;
    /* La imagen comienza en la parte superior */
    left: 45%;
    /* Centrado horizontalmente */
    transform: translateX(-50%);
    /* Asegura que esté completamente centrada */
    width: 100%;
    /* O puedes ajustar el ancho según sea necesario */
    height: auto;
    /* Mantiene las proporciones de la imagen */
}

.data-card {
    background-color: transparent;
    /* Fondo semi-transparente */
}

/* Media Queries para pantallas más pequeñas */
/* Media Queries para pantallas más pequeñas */
@media(min-width:900px) {

    /* Posicionamiento de cada cuadro de entrada en el diagrama */
    .cholesterol {
        top: 50%;
        left: 25%;
    }

    .cholesterolhdl {
        top: 50%;
        left: 45%;
    }

    .triglycerides {
        top: 50%;
        left: 65%;
    }

    .btn {
        top: 1%;
        left: 75%;
        background-color: #adb01bb1;
        /* Color naranja suave */
        border-radius: 20px;
        /* Redondeo de las esquinas */
        color: white;
        /* Color de texto blanco */
        padding: 10px 20px;
        /* Espaciado interno para hacer el botón más grande */
        border: none;
        /* Elimina el borde predeterminado */
        cursor: pointer;
        /* Cambia el cursor a mano al pasar sobre el botón */
        transition: background-color 0.3s ease;
        /* Transición suave en el cambio de color */
    }

    .btn:hover {
        background-color: #FF7F32;
        /* Un naranja más oscuro para el hover */
    }




}

@media (max-width: 900px) {
    .fishbone-container {
        background-image: none;
        /* Solo oculta la imagen de fondo, no el contenedor */
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        height: auto;
        flex-wrap: wrap;
        gap: 8px;

    }

    .fishbone-input {
        position: relative;
        width: 90%;
        margin: 5px 0;
        max-width: 400px;
        margin-left: auto;
        margin-right: auto;
    }


    .flex-container {
        display: flex;
        flex-direction: column;
        /* Cambia a columna */
        align-items: center;
    }

    .principal {
        width: 100%;
    }

    .right-panel {
        width: 100%;
    }

    .advertisement.left-ad {
        order: -1;
        /* Coloca la publicidad izquierda arriba */
    }

    .advertisement.right-ad {
        order: 2;
        /* Coloca la publicidad derecha abajo */
    }

    .logo {
        width: 100px;
        /* Hace el logo más pequeño en pantallas pequeñas */
        margin-left: 0;
        margin-right: auto;
    }

    .advertisement h1 {
        font-size: 1.5em;
        /* Reduce el tamaño del texto en la publicidad */
    }

    .data-card {
        padding: 15px;
    }

    .diagnosis-text {
        font-size: 1rem;
        /* Ajusta el tamaño del texto de diagnóstico */
    }

    .data-box {
        font-size: 0.9em;
        /* Ajusta el tamaño de las cajas de datos */
    }

    .analyzer-card {
        padding: 10px;
    }
}
</style>